<template>
  <v-container fluid class="pa-0">
    <v-card elevation="0">
      <v-card-title class="d-flex justify-space-between">
        <div>Vendor List</div>
        <div>
          <v-btn
            depressed
            rounded
            color="primary"
            @click="vendorDialog = !vendorDialog"
          >
            <i class="fas fa-plus mr-1"></i>Add New Vendor
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pa-0" style="border-top: 1px solid lightgray">
        <div style="overflow-x: auto">
          <v-data-table
            mobile-breakpoint="0"
            :headers="headers"
            :items="filteredVendors"
            :items-per-page="15"
            :options.sync="options"
            class="elevation-0"
          >
            <template v-slot:header>
              <tr>
                <th v-for="(header, idx) in headers" :key="`header-${idx}`">
                  <v-text-field
                    v-if="header.value != 'action'"
                    dense
                    class="ma-2"
                    rounded
                    v-model="filter[header.value]"
                    placeholder="filter"
                    solo-inverted
                    hide-details
                    flat
                  ></v-text-field>
                </th>
              </tr>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <a
                @click="
                  $router
                    .push({
                      name: 'VendorDetail',
                      params: { id: item.id },
                    })
                    .catch(() => {})
                "
                >{{ item.id }}</a
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                color="error"
                depressed
                icon
                @click="
                  deleteDialog = true;
                  toDeleteVendor = item.id;
                "
                :loading="toDeleteVendor == item.id"
                ><i class="fas fa-times"></i
              ></v-btn>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
    <vendor-dialog v-model="vendorDialog"></vendor-dialog>
    <general-dialog
      v-model="deleteDialog"
      :dialog="deleteDialog"
      :options="deleteOptions"
      @handle-event="deleteVendor"
    ></general-dialog>
  </v-container>
</template>
<script>
import VendorDialog from "@/components/VendorDialog.vue";
import eventBus from "@/js/event-bus.js";
import backendService from "@/services/backend-service";
import GeneralDialog from "@/components/GeneralDialog.vue";
import generalMixin from "@/js/general-mixin";
export default {
  name: "VendorList",
  components: {
    "general-dialog": GeneralDialog,
    "vendor-dialog": VendorDialog,
  },
  mixins: [generalMixin],
  data() {
    return {
      headers: [
        {
          text: "Id",
          align: "end",
          value: "id",
          width: 100,
        },
        { text: "Name", value: "name", width: 200 },
        { text: "Address 1", value: "address1", width: 300 },
        { text: "Address 2", value: "address2", width: 300 },
        { text: "Phone", value: "phone", width: 200 },
        { text: "Action", value: "action", width: 100 },
      ],
      vendorDialog: false,

      toDeleteVendor: -1,
      deleteDialog: false,
      deleteOptions: {
        btnText: "Yes",
        message: "This action is not revertable!",
        title: "Are you sure you want to delete this vendor?",
      },
    };
  },
  mounted: function () {
    return eventBus.$on("generateCsv", this.generateCsv);
  },
  computed: {
    filteredVendors() {
      let vendors = this.vendors;
      for (let key in this.filter) {
        let searchStr = this.filter[key].trim().toLowerCase();
        let header = this.headers.find((header) => header.value == key);
        if (searchStr && searchStr.length) {
          vendors = vendors.filter((e) => {
            let str = this.getDataText(header, e);
            return str
              .toString()
              .trim()
              .toLowerCase()
              .includes(this.filter[key].toLowerCase());
          });
        }
      }
      return vendors;
    },
    vendors() {
      return this.$store.getters["vendors"];
    },
    options: {
      get() {
        return this.$store.getters["interactStore/vendorOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setVendorOptions", val);
      },
    },
    filter: {
      get() {
        return this.$store.getters["interactStore/vendorFilter"];
      },
      set(val) {
        this.$store.commit("interactStore/setVendorFilter", val);
      },
    },
  },
  methods: {
    deleteVendor() {
      backendService.deleteVendorById(this.toDeleteVendor).then(() => {
        this.timer(1000)
          .then(() => {
            let newVendors = this.vendors.filter(
              (e) => e.id != this.toDeleteVendor
            );
            this.$store.commit("setVendors", newVendors);
            this.toDeleteVendor = -1;
            this.successSnackbar("Successfully updated the invoice");
          })
          .catch(() => {
            this.toDeleteVendor = -1;
            this.errorSnackbar("Ops! Something is not right");
          });
      });
    },
    generateCsv() {
      let headerStr = "Id;Name;Address 1;Address 2;Phone";
      let csvContent = "";
      csvContent += headerStr + "\r\n";

      for (let i = 0; i < this.filteredVendors.length; i++) {
        const vendor = this.filteredVendors[i];
        let rowStr = `${vendor.id};${this.getVendorName(
          vendor.id,
          false
        )};"${vendor.address1.trim()}";"${
          vendor.address2 != null ? vendor.address2.trim() : ""
        }";${vendor.phone.trim()}`;
        csvContent += rowStr + "\r\n";
      }
      let blob = new Blob([csvContent], { type: "text/plain" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `vendor-list.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDataText(header, vendor) {
      if (header.value == "id") {
        return vendor.id.toString();
      } else if (header.value == "name") {
        return vendor.name;
      } else if (header.value == "address1") {
        return vendor.address1;
      } else if (header.value == "address2" && vendor.address2 != null) {
        return vendor.address2;
      } else if (header.value == "phone") {
        return vendor.phone;
      } else {
        return "";
      }
    },
  },
  destroyed: function () {
    eventBus.$off("generateCsv");
  },
};
</script>
